import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const SPECIALTIES = [
  {
    icon: '📱',
    title: 'Réparation iPhone',
    subtitle: 'Tous modèles iPhone 11 → 16 Pro Max',
    usps: ['Écran en 15 min', 'Garantie 12 mois', 'Pièces d\'origine'],
    accent: 'from-blue-500/20 to-blue-600/10 border-blue-500/30',
    tag: 'text-blue-400',
    url: '/reparation-iphone-villeurbanne',
  },
  {
    icon: '📲',
    title: 'Réparation Samsung',
    subtitle: 'Galaxy S & A Series — Écrans AMOLED',
    usps: ['Écran en 30 min', 'Garantie 12 mois', 'AMOLED certifié'],
    accent: 'from-cyan-500/20 to-cyan-600/10 border-cyan-500/30',
    tag: 'text-cyan-400',
    url: '/reparation-samsung-villeurbanne',
  },
  {
    icon: '🔋',
    title: 'Remplacement Batterie',
    subtitle: 'iPhone, Samsung, Android, PC, Tablette',
    usps: ['Express 15 min', 'Capacité 100%', 'Garantie 6 mois'],
    accent: 'from-emerald-500/20 to-emerald-600/10 border-emerald-500/30',
    tag: 'text-emerald-400',
    url: '/reparation-batterie-villeurbanne',
  },
  {
    icon: '💻',
    title: 'PC Portable & Mac',
    subtitle: 'MacBook, Windows, iMac — Toutes marques',
    usps: ['Écran, clavier, charnières', 'SSD upgrade', 'Diagnostic gratuit'],
    accent: 'from-purple-500/20 to-purple-600/10 border-purple-500/30',
    tag: 'text-purple-400',
    url: '/reparation-ordinateur-villeurbanne',
  },
  {
    icon: '📟',
    title: 'Tablettes',
    subtitle: 'iPad, Galaxy Tab & Microsoft Surface',
    usps: ['Expertise Surface unique', 'Écran & batterie', 'Garantie 6-12 mois'],
    accent: 'from-orange-500/20 to-orange-600/10 border-orange-500/30',
    tag: 'text-orange-400',
    url: '/reparation-tablette-villeurbanne',
  },
  {
    icon: '🔬',
    title: 'Micro-soudure',
    subtitle: 'Carte mère & récupération de données',
    usps: ['Quand tout le monde dit non', 'Reballing BGA', 'Récupération données'],
    accent: 'from-red-500/20 to-red-600/10 border-red-500/30',
    tag: 'text-red-400',
    url: '/micro-soudure-villeurbanne',
  },
];

export const OurSpecialties = () => {
  return (
    <section id="specialites" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-black/45 backdrop-blur-[2px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* En-tête */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur border border-white/20 rounded-full px-5 py-1.5 mb-5">
            <span className="text-white/80 text-sm font-semibold tracking-wide">Expertise reconnue à Villeurbanne</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nos Spécialités
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Du remplacement d'écran express à la micro-soudure de carte mère — nous maîtrisons chaque geste technique
            pour redonner vie à vos appareils.
          </p>
        </div>

        {/* Grille 6 cartes */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SPECIALTIES.map((s, i) => (
            <Link
              key={i}
              to={s.url}
              data-testid={`specialty-card-${i}`}
              className={`group flex flex-col bg-gradient-to-br ${s.accent} border rounded-2xl p-6 hover:scale-[1.02] transition-all duration-200 hover:shadow-lg`}
            >
              {/* Icône + titre */}
              <div className="flex items-start gap-4 mb-4">
                <span className="text-4xl">{s.icon}</span>
                <div>
                  <h3 className="font-bold text-white text-lg leading-tight">{s.title}</h3>
                  <p className="text-white/50 text-sm mt-0.5">{s.subtitle}</p>
                </div>
              </div>

              {/* USPs */}
              <ul className="space-y-1.5 mb-5 flex-1">
                {s.usps.map((u, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-white/70">
                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${s.tag.replace('text-', 'bg-')}`} />
                    {u}
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <div className={`flex items-center gap-1.5 text-sm font-semibold ${s.tag} group-hover:gap-3 transition-all`}>
                Voir les tarifs
                <ArrowRight size={15} />
              </div>
            </Link>
          ))}
        </div>

        {/* Mention géo bas */}
        <p className="text-center text-white/35 text-sm mt-10">
          📍 Boutique accessible en Tram T6 — arrêt Gratte-Ciel, 6 Rue Paul Verlaine, Villeurbanne (69100)
        </p>

      </div>
    </section>
  );
};
